import React from 'react';
import { inject, observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import Dropzone from 'react-dropzone';

import DragAndDrop from 'components/DragAndDrop/DragAndDrop';
import messages from '../messages';

const dropZoneStyle = {
  position: 'relative',
  width: '100%',
  height: '100%',
  minHeight: '270px'
};

const AnalyseDropZone = ({
  onDrop,
  canDrop,
  intl,
  progressLabel = '',
  fileUploadStore: { currentFileUpload, totalFileUpload, uploadProgress }
}) => (
  <Dropzone
    style={dropZoneStyle}
    accept="video/*,video/mp4,video/mov"
    onDrop={onDrop}
    disabled={!canDrop}
  >
    {({ isDragActive, isDragReject }) => {
      let dropState = 'default';
      progressLabel = intl.formatMessage(
        messages.analyseOverviewVideoUploadDefault
      );
      if (isDragActive) {
        dropState = 'isDragActive';
        progressLabel = intl.formatMessage(
          messages.analyseOverviewVideoUploadActive
        );
      }
      if (isDragReject) {
        dropState = 'isDragReject';
        progressLabel = intl.formatMessage(
          messages.analyseOverviewVideoUploadReject
        );
      }
      if (!canDrop) {
        dropState = 'acceptedFiles';
        progressLabel = intl.formatMessage(
          messages.analyseOverviewVideoUploadProgress,
          {
            progress: `${currentFileUpload}/${totalFileUpload}`
          }
        );
      }
      return (
        <DragAndDrop
          status={
            dropState
            // style={{ height: 200 }}
          }
          calcPercent={Math.round(uploadProgress * 100)}
          progressLabel={progressLabel}
        />
      );
    }}
  </Dropzone>
);
export default injectIntl(inject('fileUploadStore')(observer(AnalyseDropZone)));



// WEBPACK FOOTER //
// ./src/containers/analyse/components/AnalyseDropZone.js